module.exports = __webpack_public_path__ + "static/12-6a057f7b0bde8e7e8a8a602167a3e6d7.png";